<template>
  <el-form-item
    class="form form-date-cascader"
    :label="column.label"
    :prop="column.name">
    <el-cascader
      style="display:inline-block;"
      v-model="form[column.name]"
      @change="onRangeChanged"
      :options="(options || [])"
      :clearable="column.clearable || undefined"
      :show-all-levels="column.hasOwnProperty('showAllLevels') ? column.showAllLevels : false"
      expand-trigger="hover"
      :props="{ expandTrigger: 'hover' }"
      :disabled="disabled"
      :style="column.controlStyle || { width: '100%' }">
      <template slot="prefix">
        <i class="el-icon-date" style="padding:13px 6px;"></i>
      </template>
    </el-cascader>
  </el-form-item>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'form-date-cascader',
  components: {
  },
  props: ['column', 'form', 'options', 'data', 'disabled'],
  data () {
    return {
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
    },

    // getData (name) {
    //   if (this.data && this.data[name] && typeof this.data[name] === 'object') {
    //     return this.data[name]
    //   }
    //   return []
    // },

    onRangeChanged () {
      let value = this.form[this.column.name]
      let colinfo = _.assign({}, this.column, { value })
      this.$emit('on-range-changed', colinfo)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

// .form-date-cascader {
// }

</style>
